<template>
  <div class="show-box">
    <!-- Header -->
    <div class="header container">
      <!-- <div class="header-flower"></div> -->
      <view-nav></view-nav>
      <div class="title-box wrap">
        <div class="title-show-box">
          <h2>全国博物馆</h2>
          <h3>网上精品展览展示平台</h3>
        </div>
        <!--<img class="showtitle" src="../assets/images/showtitle.png" alt="">-->
        <!-- <div class="text1" style="marginLeft: 35px">第十七届（2019年度）</div>
        <div class="text2">全国博物馆</div>
        <div class="text2">十大陈列展览精品推荐活动</div> -->
        <div class="btn-box1 box" @click.stop="util.toDeclare()">
          <p>立即申报</p>
        </div>
        <!--<div class="btn-box1 box" @click.stop="util.toDeclare()">-->
          <!--&lt;!&ndash; <p>网上展览</p> &ndash;&gt;-->
          <!--<img src="../assets/images/pingshenBtn.png" alt="">-->
        <!--</div>-->
        <div class="search-input-box">
          <i></i>
          <input type="text" placeholder="快速搜索展览" v-model="searchText" @keyup.enter="toSearchExhibition(true, '', 1)">
        </div>
        <!-- <img class="img" src="../assets/images/show-page-img.png" alt="">
        <div class="top-swiper-box">
          <swiper class="show-top-swiper" :options="swiperOption" ref="showTopSwiper">
            <swiper-slide class="swiper-card" v-for="(item, index) in headerList" :key="index">
              <div class="img-box" @click="toDetail(item.id)">
                <img class="backimg" :src="util.getPicUrl(item.cover, 'imgsmall')" alt="">
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div> -->
        <!-- <div class="btn-box box" @click.stop="util.toDeclare()">
          <p>展览上传</p>
        </div> -->
      </div>
    </div>
    <div class="search-box container">
      <div class="searchTabs">
        <ul class="clearfix">
          <li v-for="(item, ind) in searchTabs" :key="ind" @click="toSearchExhibition(true,item.val,ind+1)" :class="{'activeLi': isActive === ind+1}">{{item.name}}</li>
          <!--<li :class="{'activeLi': isActive === 4}" @click="toSearchHexin(true, 4)">核心价值观</li>-->
        </ul>
      </div>
      <div class="tip-text wrap">以行政区划为序</div>
      <div class="search-result-box wrap">
        <div class="list-box wrap" v-if="list.length > 0">
          <show-list :list="list" @addZan="addZan"></show-list>
          <div class="loading">
            <img v-if="isloading" src="/gif/loading.gif" alt="">
            <!-- <img class="readmore" v-if="!isloading && (list.length < total)" @click="loadMore" src="../assets/images/readmore.png"> -->
          </div>
        </div>
        <div class="no-search wrap" v-if="list.length === 0">
          <img src="../assets/images/no-data.png" alt="">
          <p>暂无展览</p>
        </div>
      </div>
    </div>
    <!--返回顶部-->
    <div class="return-top-btn" @click="returnTop"></div>
  </div>
</template>
<script>
import ShowList from '../components/ShowList2'
let scrollListener = null
export default {
  name: 'Show',
  components: {
    'show-list': ShowList
  },
  data () {
    return {
      isloading: false,
      isActive: 1,
      searchTabs: [
        {
          name: '全部展览',
          key: '',
          val: ''
        },
        {
          name: '境内展览',
          val: 1
        },
        {
          name: '入境展览',
          val: 3
        },
        {
          name: '出境展览',
          val: 2
        }
      ],
      areaId: '',
      exhibitionAge: '',
      searchText: '',
      labelArray: [
        {
          value: '',
          text: '全部'
        }
      ],
      label: '',
      labelText: '',
      list: [],
      headerList: [],
      offset: 0,
      limit: 100000,
      currentPage: 1,
      total: 0,
      swiperOption: {
        // slidesPerView: 3,
        // slidesPerGroup: 1,
        // freeMode: true,
        slidesPerView: 'auto',
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  created () {
  },
  mounted () {
    this.util.addMtah5ClickStat('show')
    this.getLabel()
    this.toSearchExhibition(true, this.searchTabs[this.isActive - 1].val, this.isActive)
    // 废弃上拉加载更多功能 改为点击加载更多
    // setTimeout(() => {
    //   let scrollAction = { x: undefined, y: undefined }
    //   scrollListener = () => {
    //     let scrollDom = document.documentElement || document.body
    //     if (typeof scrollAction.y === 'undefined') {
    //       scrollAction.y = scrollDom.scrollTop
    //     }
    //     let diffY = scrollAction.y - scrollDom.scrollTop
    //     scrollAction.y = scrollDom.scrollTop
    //     if ((scrollDom.scrollTop + 5 >= scrollDom.scrollHeight - scrollDom.clientHeight) && this.list.length < this.total && diffY < 0) {
    //       this.isloading = true
    //       this.currentPage++
    //       this.toSearch('', this.areaId)
    //     }
    //   }
    //   this.util.addEvent(window, 'scroll', scrollListener)
    //   // window.addEventListener('scroll', scrollListener)
    // }, 1000)
  },
  beforeDestroy () {
    this.util.removeEvent(window, 'scroll', scrollListener)
    // window.removeEventListener('scroll', scrollListener)
  },
  methods: {
    toDetail (id) {
      this.$router.push('/detail/' + id)
    },
    getLabel () {
      this.$api.getLabel().then(res => {
        let data = res.data.data
        for (let i in data) {
          let json = {}
          json['value'] = i
          json['text'] = data[i]
          this.labelArray.push(json)
        }
      })
    },
    toSearchExhibition (value, num, ind) {
      if (value) {
        this.currentPage = 1
      }
      if (ind) {
        this.isActive = ind
      }
      this.areaId = num
      let params = {
        label: this.label,
        limit: this.limit,
        keyword: this.searchText,
        areaId: this.areaId,
        activityId: 5
      }
      this.$api.getExhibitionList({ params: params }).then(res => {
        res.data.data.rows.forEach(element => {
          if (!element.thumbNum) {
            element.thumbNum = 0
          }
          if (!element.cover) {
            element.cover = '//vepic-material.vizen.cn/release/pic/dd7dc7c643c3e973ccd165333499ef6b.png'
          }
        })
        this.total = res.data.data.total
        if (this.currentPage === 1) {
          this.list = res.data.data.rows
        } else {
          this.isloading = false
          this.list = this.list.concat(res.data.data.rows)
        }
      })
    },
    changeLabel (value, text) {
      this.label = value
      this.labelText = text
      this.toSearchExhibition(true)
    },
    addZan (index) {
      if (!this.list[index].isZan) {
        this.$api.addExhibitionThumbUp(this.list[index].id).then(res => {
          let item = this.list[index]
          item.isZan = true
          item.thumbNum = item.thumbNum + 1
          this.list.splice(index, 1, item)
        })
      }
    },
    returnTop () {
      let iSpeed = 0
      clearInterval(this.iTimer)
      this.iTimer = setInterval(() => {
        let heightTop = document.documentElement.scrollTop || document.body.scrollTop
        iSpeed = Math.floor((0 - heightTop) / 8)
        document.body.scrollTop = heightTop + iSpeed
        document.documentElement.scrollTop = heightTop + iSpeed
        if (document.body.scrollTop <= 0 && document.documentElement.scrollTop <= 0) {
          clearInterval(this.iTimer)
        }
      }, 30)
      // document.body.scrollTop = 0
      // document.documentElement.scrollTop = 0
    },
    alertSomething (str) {
      alert(str)
    }
  }
}
</script>
<style lang="scss">
  .show-box{
    .header {
      height: 430px;
      // background: linear-gradient(180deg, #FF4A21 0%, #AA0907 100%);
      background: url('../assets/images/showheaderdist.png') no-repeat 0 0;
      position: relative;
      background-size: cover;
      // &::after{
      //   content: ' ';
      //   position: absolute;
      //   left: 0;
      //   top: 0;
      //   right: 0;
      //   bottom: 0;
      //   background: url("../assets/images/showheader.png") repeat-x 0 0;
      //   background-size: 100% 810px;
      // }
      .header-flower{
        width: 750px;
        height: 750px;
        position: absolute;
        left: -50px;
        top: -100px;
        background: url("../assets/images/header-flower-small.png") no-repeat 0 0;
        background-size: 100% 100%;
      }
    }
    .title-box{
      height: 326px;
      position: relative;
      z-index: 99;
      text-align: center;
      .title-show-box{
        padding-top: 20px;
        color: #ffffff;
        text-shadow: 1px 1px 3px #999999;
        line-height: 1.5;
        h2{
          font-size: 36px;
          letter-spacing: 4px;
        }
        h3{
          font-size: 50px;
          letter-spacing: 10px;
        }
      }
      img.showtitle {
        width: 660px;
      }
      .img{
        width: 300px;
        height: 380px;
        position: absolute;
        left: 20px;
        bottom: 73px;
      }
      .title{
        position: absolute;
        right: 40px;
        top: 65px;
        h2{
          font-weight: bold;
          font-size: 50px;
          color: #FFC526;
          letter-spacing: 0;
          line-height: 50px;
        }
        p{
          margin-top: 20px;
          font-size: 16px;
          color: #FFC526;
          letter-spacing: 0;
          line-height: 32px;
        }
      }
      .btn-box1{
        position: absolute;
        left: 50%;
        bottom: 110px;
        display: inline-block;
        cursor: pointer;
        padding: 12px 32px;
        background: linear-gradient(167deg, #FFE5B8 4%, #D39F51 100%);
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10);
        border-radius: 25px;
        text-align: center;
        transform: translateX(-50%);
        &:hover{
          background: #ffffff;
        }
        p {
          font-size: 22px;
          color: #561014;
          letter-spacing: 2px;
          line-height: 26px;
          font-weight: bold;
        }
      }
      .text1 {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        font-weight: 200;
        // line-height: 38px;
        margin-bottom: 10px;
      }
      .text2 {
        font-family: Helvetica;
        font-size: 42px;
        color: #FFFFFF;
        letter-spacing: 2.66px;
        text-align: center;
        line-height: 60px;
        text-shadow: 0 2px 4px rgba(79,79,79,0.24);
      }
      .search-input-box {
        // width: 850px;
        // height: 60px;
        margin-top: 95px;
        position: relative;
        i {
          // content: ' ';
          display: block;
          width: 26px;
          height: 26px;
          background: url("../assets/images/sousuo-2.png") no-repeat 0 0;
          background-size: 100% 100%;
          position: absolute;
          left: 360px;
          bottom: 13px;
          z-index: 99;
          opacity: .7;
          // transform: translateY(-50%);
        }
        input {
          width: 528px;
          height: 50px;
          box-sizing: border-box;
          border-radius: 34px;
          padding: 0 73px;
          position: relative;
          font-size: 18px;
        }
        ::-webkit-input-placeholder {
          /* WebKit browsers */
          font-family: PingFangSC-Regular;
          font-size: 18px;
          color: #CCCCCC;
          letter-spacing: 1.4px;
        }
      }
    }
    .show-top-swiper{
      width: 645px;
      height: 302px;
      .swiper-card{
        width: 200px;
        height: 302px;
        margin-right: 10px;
        margin-left: 5px;
      }
      .img-box{
        width: 198px;
        height: 300px;
        border-radius: 3px;
        font-size: 0;
        overflow: hidden;
        position: relative;
        border: 1px solid #FAD194;
        box-shadow: 0 1px 4px 0 rgba(0,0,0,0.30);
        cursor: pointer;
        &:hover{
          .backimg{
            transform: scale3d(1.1, 1.1, 1);
            transition: transform 0.6s !important;
          }
        }
        .backimg{
          width: 198px;
          height: 300px;
          transition: transform 0.3s;
        }
      }
    }
    .top-swiper-box{
      width: 765px;
      height: 302px;
      position: absolute;
      right: 20px;
      bottom: 144px;
      .swiper-button-prev{
        width: 40px;
        height: 40px;
        background: url("../assets/images/swiper-left.png") no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -20px;
      }
      .swiper-button-next{
        width: 40px;
        height: 40px;
        background: url("../assets/images/swiper-left.png") no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -20px;
        transform: rotateZ(180deg);
      }
    }
    .return-top-btn{
      width: 80px;
      height: 80px;
      background: url("../assets/images/top.png") no-repeat 0 0;
      background-size: 100% 100%;
      position: fixed;
      right: 60px;
      bottom: 180px;
      z-index: 20;
      cursor: pointer;
      transition: all 0.6s;
      &:hover{
        transform: scale3d(1.1, 1.1, 1);
      }
    }
    .search-btn-box{
      width: 972px;
      margin: 50px auto 50px;
      padding: 40px 31px 13px 47px;
      background: #f8f8f8;
      border-radius: 4px;
      .btn{
        display: inline-block;
        padding: 13px 16px;
        background: rgba(0,0,0,0);
        border-radius: 3px;
        margin-right: 34px;
        margin-bottom: 27px;
        cursor: pointer;
        p{
          font-size: 24px;
          color: #35343D;
          letter-spacing: 0;
          line-height: 24px;
        }
        &.select{
          background: linear-gradient(180deg, #FF4A21 0%, #AA0907 100%);
          p{
            color: #FFFFFF;
          }
        }
      }
    }
    .searchTabs {
      margin: auto;
      margin-top: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      ul {
        li {
          cursor: pointer;
          box-sizing: border-box;
          padding: 0 10px;
          line-height: 46px;
          height: 46px;
          float: left;
          color: #35343D;
          font-size: 24px;
          margin: 0 45px;
          border-radius: 5px;
          // &:hover {
          //   background: url('../assets/images/tabBgc.png');
          //   background-size: cover;
          //   color: #fff;
          // }
        }
        .activeLi {
          background: url('../assets/images/tabBgc.png');
          background-size: cover;
          color: #fff;
        }
      }
    }
    .tip-text{
      margin-top: 25px;
      text-indent: 30px;
      font-size: 20px;
      line-height: 30px;
      color: #999999;
      position: relative;
      &::before{
        content: ' ';
        width: 20px;
        height: 20px;
        background: #999999;
        border-radius: 50%;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -10px;
      }
    }
    .search-result-box{
      margin-top: 20px;
      padding-bottom: 60px;
      .search-result-tip{
        width: 1050px;
        margin: 0 auto 30px;
        h4{
          font-size: 24px;
          color: #D0021B;
          letter-spacing: 3px;
          line-height: 24px;
          display: inline-block;
          margin-right: 10px;
        }
        p{
          display: inline-block;
          font-size: 24px;
          color: #35343D;
          letter-spacing: 3px;
          line-height: 24px;
          span{
            color: #D0021B;
          }
        }
      }
      .list-box{
        height: auto;
        ul{
          height: auto;
        }
        .loading {
          height: 40px;
          text-align: center;
          img {
            width: 40px;
          }
          img.readmore {
            width: 120px;
            cursor: pointer;
          }
        }
      }
      .no-search{
        text-align: center;
        img{
          width: 316px;
          height: 232px;
        }
        p{
          width: 100%;
          font-size: 16px;
          color: #35343D;
        }
      }
    }
  }
</style>
